module.exports = __webpack_public_path__ + "faf3b2497c443476c36b1ccd4e71d172.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/io.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/io.svg
// module chunks = 0